"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'access.list.searchPlaceholder': 'Cerca politiche di accesso...',
};
